import { Component, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';

import { ItemService } from '../../../service/item/item.service';
import { OwnerService } from '../../../service/owner/owner.service';
import { TypeColdService } from '../../../service/type-cold/type-cold.service';
import { UnitService } from '../../../service/unit/unit.service';
import { CommonService } from '../../../service/common/common.service';
import { DialogsService } from '../../../../component/dialog/dialogs.service';
import { environment } from '../../../../environments/environment';
import { config } from '../../../util/config';

@Component({
  selector: 'app-root',
  templateUrl: 'wa9104.component.html',
  styleUrls: ['wa9104.component.css']
})
export class Wa9104Component implements AfterViewInit {
  public componentTitle = 'WA9104:商品画像修正';

  public typecolds: any;
  public units: any;
  public owners: any;

  public items: object;
  public ownerId: number;
  public itemId: number;
  public itemPictures: string;
  public picture: string;
  public pictureCount: number;
  public imgFileName: string;
  public imgPath: string;

  public working = false;
  public containerHeight = 500;
  public production = environment.production;
  public backgroundColor: string;

  constructor(
    private router: Router,
    private itemService: ItemService,
    private ownerService: OwnerService,
    private typeColdService: TypeColdService,
    private unitService: UnitService,
    private commonService: CommonService,
    private dialogsService: DialogsService
  ) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }
    this.working = true;
  }

  onResize(event) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.onView();
    }, 500);
  }

  onView() {
    this.items = JSON.parse(sessionStorage.getItem('rowItems'));

    if (this.items === null) {
      this.router.navigate([
        JSON.parse(sessionStorage.getItem('loginResult')).user.roleId === 3  
        ? 'wa0003' : 'wa0002']);
      return;
    }

    this.ownerId = this.items['ownerId'];
    this.itemId = this.items['itemId'];
    this.itemPictures = this.items['itempictures'];

    if (this.itemPictures && this.isJSON(this.itemPictures) == true) {
      this.picture = JSON.parse(this.itemPictures);
      this.pictureCount = Object.keys(this.picture).length;

      for (var i = 0; i < this.pictureCount; i++) {
        if (this.picture[i + 1]) {
          this.imgFileName = this.picture[i + 1];
        }
      }

      this.imgPath = environment.imagePath + this.imgFileName;
      console.log('this.imgPath？=======' + this.imgPath);
    }
    this.working = false;
  }

  onSubmit() {
    this.router.navigate(['wa9102']);
  }

  onDelete() {
    this.maItemUpload(this.imgFileName);
    this.deleteImageFile(this.imgFileName);
  }

  maItemUpload(fileName) {
    var jsonObject = { '1': '', '2': '', '3': '', '4': '', '5': '' };

    for (var i = 1; i <= 5; i++) {
      if (this.items['itempictures'] && this.isJSON(this.items['itempictures']) == true) {
        this.picture = JSON.parse(this.items['itempictures']);
        if (this.picture[i] == fileName) {
          delete jsonObject[i];
        } else {
          jsonObject[i] = this.picture[i];
        }
      } else {
        delete jsonObject[i];
      }
    }

    this.working = true;
    let paramJson: string = this.isJSON(jsonObject) ? JSON.stringify(jsonObject) : '';
    this.items['itempictures'] = paramJson;
    sessionStorage.setItem('rowItems', JSON.stringify(this.items));

    this.itemService
      .updateImages(this.items['itemId'], paramJson)
      .then(outputJson => {
        this.working = false;
        this.router.navigate(['wa9102']);
      })
      .catch(error => {
        this.working = false;
        this.router.navigate(['wa9102']);
        console.log(fileName + 'DB保存が失敗しました。');
      });
  }

  //サーバーファイル削除
  deleteImageFile(downFileName) {
    this.itemService
      .deleteImageFile(downFileName)
      .then(outputJson => {
        console.log(downFileName + outputJson['message']);
      })
      .catch(error => {
        console.log(downFileName + '削除が失敗しました。');
      });
  }

  /*-----------------------------------
  JSON判定関数
    指定された文字列がJSONか否かを判定する。
  -------------------------------------*/
  isJSON(arg) {
    arg = typeof arg === 'function' ? arg() : arg;
    if (typeof arg !== 'string') {
      return false;
    }
    try {
      arg = !JSON ? eval('(' + arg + ')') : JSON.parse(arg);
      return true;
    } catch (e) {
      return false;
    }
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa9Master/wa9104/wa9104.component.ts